import React from 'react';

interface FeaturedBlogColumnProps {
  children?: React.ReactNode;
}

export const FeaturedBlogColumn = ({ children }: FeaturedBlogColumnProps) => {
  return (
    // gap: small screens 8px (gap-2), md and up 16px (md:gap-4)
    <div className="flex flex-col items-start gap-4 h-full">
      <h2 className="text-white text-lg font-bold mb-2">Featured posts</h2>
      <div className="flex flex-col flex-1 w-full gap-3 items-start">
        {children}
      </div>
    </div>
  );
};
